import styled from 'styled-components';
import { Menu as MenuComponent } from '@pearsontechnology/aero-components';

export const Menu = styled(MenuComponent)`
  margin-top: 5px;
  white-space: nowrap;
`;

export const LessonName = styled.span`
  margin-left: 15px;
`;

export const MenuListItemText = styled.div`
  margin: 0 4px;
  width: 100%;
`;
